import WorkerAutocompleteBaseController from "./worker_autocomplete_base"

export default class extends WorkerAutocompleteBaseController {
  static identifier = "gift-autocomplete"
  static targets = ["input", "datalist", "hidden"]
  static values = { url: String }

  onInput() {
    if (this.hasHiddenTarget) this.hiddenTarget.value = ""
    this.onAutocompleteInput({ minQueryLength: 2, delay: 200 })
  }

  onChange() {
    if (!this.hasHiddenTarget || !this.hasDatalistTarget) return

    const query = this.inputTarget.value.trim()
    const match = Array.from(this.datalistTarget.querySelectorAll("option")).find(
      (option) => option.value === query
    )

    this.hiddenTarget.value = match?.dataset?.workerId || ""
  }

  renderWorkerResults(workers) {
    const datalist = this.datalistTarget
    while (datalist.firstChild) datalist.removeChild(datalist.firstChild)

    workers.forEach((worker) => {
      if (!worker?.name) return
      const option = document.createElement("option")
      option.value = worker.name
      option.dataset.workerId = worker.id
      datalist.appendChild(option)
    })
  }
}

